import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { AccessService } from '@cm/ui-modules';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { CmUiChipComponent } from '@cm/ui-modules';
import { parseSystemUpdateBody } from '@modules/system-updates/system-update-body.parser';
import { SystemPage } from '@modules/system-updates/system-pages.config';

/**
 * Renders a system update body: plain text with `[[page_key]]` markers turned into inline chips
 * that navigate to that page. A page the reader has no access to shows as plain text instead of a
 * link that would bounce to no-access; an unknown marker is dropped (see the parser).
 * Shared by the bottom-right panel, the archive feed and the editor preview.
 */
@Component({
  selector: 'app-system-update-body',
  standalone: true,
  // no SHARED_IMPORTS: it carries CmAccessModuleModule, whose TokenService provider would give the
  // component tree that mounts this (AppComponent, via the panel) a second, empty TokenService
  imports: [RouterLink, TranslatePipe, CmUiChipComponent],
  templateUrl: './system-update-body.component.html',
  styleUrls: ['./system-update-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SystemUpdateBodyComponent {
  private readonly access = inject(AccessService);

  readonly body = input<string | null | undefined>('');

  protected readonly segments = computed(() => parseSystemUpdateBody(this.body()));

  protected canOpen(page: SystemPage): boolean {
    return !page.access || this.access.checkAccess(page.access);
  }
}
